import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getHardware } from '../../../../api/hardware';

const useAllHardware = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>,
  parameters?: {
    organization_id?: string | null;
    paginationResultHandler?: Function;
    systemId?: string;
  }
) => {
  return useQuery({
    queryKey: ['allHardware', parameters?.organization_id, parameters?.systemId],
    queryFn: () => getHardware(parameters, parameters?.paginationResultHandler),
    ...options,
  });
};

export default useAllHardware;
